import { createSlice } from "@reduxjs/toolkit";
import { fetchDashboardData } from "../Thunks/dashboardThunk";
import { normalizeDashboardPayload } from "../../utils/dashboardPayload";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboard: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchDashboardData, {
      onFulfilled: (state, action) => {
        state.data = normalizeDashboardPayload(action.payload);
      },
    });
  },
});

export const { clearDashboard } = dashboardSlice.actions;
export const selectDashboardData = (state) => state.dashboard.data;
export const selectDashboardLoading = (state) => state.dashboard.loading;
export const selectDashboardError = (state) => state.dashboard.error;

export default dashboardSlice.reducer;
